// The frame's keyboard map (shell-ia §5.5): ⌘K or "/" search · ⌘. the agent · ⌘J a new conversation · ⌘⇧D the department switcher ·
// "g" then h / e / w / k (ECONIC, Agents, My workspace, Knowledge Bank), i / c (Inbox, Conversations), s (Trust Centre) ·
// "?" the shortcuts. Single keys never fire while typing. WP-SHELL.
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useKeyboardShortcuts } from "@ncp/ui";

export const GO_KEYS: Record<string, string> = { h: "/", e: "/intelligence", w: "/my-workspace", k: "/knowledge", i: "/inbox", c: "/chat", s: "/trust" };

export function useShellKeyboard(handlers: { openSearch: () => void; openShortcuts: () => void; newChat: () => void; toggleAgent: () => void; openDepartments: () => void }): void {
  const navigate = useNavigate();
  const ref = useRef(handlers);
  ref.current = handlers;
  useKeyboardShortcuts({
    onPalette: () => ref.current.openSearch(),
    onSearch: () => ref.current.openSearch(),
    onHelp: () => ref.current.openShortcuts(),
    onNew: () => ref.current.newChat(),
    onGo: (letter) => {
      const to = GO_KEYS[letter];
      if (to) navigate(to);
    },
  });
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const mod = e.metaKey || e.ctrlKey;
      if (!mod) return;
      if (e.key === "." && !e.shiftKey && !e.altKey) {
        e.preventDefault();
        ref.current.toggleAgent();
      } else if (e.shiftKey && (e.key === "D" || e.key === "d")) {
        e.preventDefault();
        ref.current.openDepartments();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
}
